import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				alignItems: "center"
			},
			btnDefault: {
				display: "flex",
				background: theme.palette.grey[200],
				fontSize: 35,
				color: theme.palette.grey[400],
				width: 26,
				padding: 5,
				height: 26,
				justifyContent: "center",
				alignItems: "center",
				borderRadius: 4,
				borderColor: theme.palette.grey["A100"],
				"&:hover": {
					opacity: 0.7
				}
			},
			textValue: {
				color: theme.palette.secondary.contrastText,
				fontSize: 15,
				margin: "0px 15px"
			}
		}),
	{
		name: "GroupedButtons",
		index: 1
	}
);

export default useStyles;
